import React, { useEffect, useState } from 'react';
import ActionCallBanner from './ActionCallBanner';
import StartCallBanner from './StartCallBanner';
import RegisterCallModal from '../RegisterCallModal';

const CallStages = Object.freeze({
  prompt: 'prompt',
  in_progress: 'in_progress',
  ended: 'ended',
});

const canProgressStage = (previousCallStage, callStage) => {
  switch (previousCallStage) {
    case undefined:
      return callStage === CallStages.prompt;
    case CallStages.prompt:
      return callStage === CallStages.in_progress;
    case CallStages.in_progress:
      return callStage === CallStages.ended;
    case CallStages.ended:
      return false;
    default:
      return false;
  }
};

const VoiceCallingBanners = options => {
  const [previousCallStage, setPreviousCallStage] = useState(undefined);
  const [opts, setOpts] = useState(options);
  const [open, setOpen] = useState(options.open);

  const canUpdateOpts =
    previousCallStage === undefined ||
    previousCallStage === CallStages.prompt ||
    options.callStage === CallStages.ended;

  const canProgress = canProgressStage(previousCallStage, options.callStage);
  const callStage = canProgress ? options.callStage : previousCallStage;

  useEffect(() => {
    if (canProgress) {
      setPreviousCallStage(callStage);
    }
  }, [callStage, canProgress]);

  useEffect(() => {
    if (canUpdateOpts) {
      setOpts(options);
    }
  }, [options, canUpdateOpts]);

  switch (callStage) {
    case CallStages.prompt:
      return <StartCallBanner {...opts} />;
    case CallStages.in_progress:
      return <ActionCallBanner {...opts} />;
    case CallStages.ended:
      return (
        <RegisterCallModal
          open={open}
          close={() => setOpen(false)}
          task={opts.task}
          callId={opts.callId}
          recordingId={opts.recordingId}
          contactId={opts.contactId}
          result={opts.result}
          onClosed={() => opts.close()}
        />
      );
    default:
      return null;
  }
};

export default VoiceCallingBanners;
export { CallStages };
